(() => {
  angular
    .module('app.campaign')
    .controller('AddTrackpointModalController', AddTrackpointModal);

  AddTrackpointModal.$inject = [
    '$scope',
    '$element',
    'close',
    'ModalService',
    'AccountService',
    'CampaignService',
    'currentCampaign',
    'TrackpointService',
    'CampaignManagerService',
  ];

  function AddTrackpointModal(
    $scope,
    $element,
    close,
    ModalService,
    AccountService,
    CampaignService,
    currentCampaign,
    TrackpointService,
    CampaignManagerService,
  ) {
    const vm = this;
    let cCodes = [];

    vm.maxTrackpointsAllowed = 1000;
    vm.newTrackpoints = [];
    vm.rawTrackpoints = null;
    vm.validTrackpoints = [];

    vm.campaignsList = [];

    const lower = str => str.toLowerCase();

    const checkTrackpointsAdded = () => {
      // mark trackpoints which are already in the campaign
      currentCampaign.trackpoints.forEach(targetTrackpoint => {
        vm.campaignsList.forEach(campaign => {
          campaign.trackpoints.forEach(tp => {
            if (lower(tp.cid) === lower(targetTrackpoint.cid)
              && lower(tp.tailcode) === lower(targetTrackpoint.tailcode)) {
              tp.cannotBeAdded = true;
            }
          });
        });
      });
    }



    /* *************************************** */
    /* ************** Campaigns ************** */
    /* *************************************** */
    let loadPage = 0;
    const itemsPerPage = 7;
    const loadChunk = (page = loadPage, perPage = itemsPerPage) => (
      CampaignService.getCampaignsWithTrackpointsList({ page, perPage }).$promise);

    vm.loadNextChunk = (nextPage = 0) => {
      vm.nextChunkLoaded = false;

      loadChunk()
        .then(({ data, total }) => {
          vm.campaignsList = [
            ...vm.campaignsList,
            ...data,
          ];
          vm.totalItemsCount = total;
          vm.nextChunkLoaded = true;

          showPage(nextPage);
          checkTrackpointsAdded();

          if (vm.campaignsList.length < total) {
            loadPage += 1;
          }
        });
    };

    vm.isCampaignDisabled = campaign => campaign.trackpoints.length === 0 || campaign.pid === currentCampaign.pid;



    activate();
    function activate() {
      AccountService.getSupportedCids().then(function (data) {
        cCodes = data;
        vm.allowedCids = _.pluck(cCodes, 'cid');
      });
    }

    vm.isCampaignAllTrackpointsAdded = campaign => campaign.trackpoints.every(tp => tp.cannotBeAdded);

    vm.addTrackpoint = tp => {
      currentCampaign.trackpoints.push({
        ...tp,
        cannotBeAdded: true,
      });

      checkTrackpointsAdded();
    };

    vm.addAllCampaignTrackpoints = campaign => {
      campaign.trackpoints.forEach(tp => {
        if (!tp.cannotBeAdded) {
          currentCampaign.trackpoints.push({
            ...tp,
            cannotBeAdded: true,
          });
        }
      });

      checkTrackpointsAdded();
    };




    /* ******************************************** */
    /* **************** Pagination **************** */
    /* ******************************************** */
    vm.currentPage = 1;
    vm.totalPages = () => vm.totalItemsCount ? Math.ceil(vm.totalItemsCount / itemsPerPage) : '…';

    vm.isFirstPage = () => vm.currentPage === 1;
    vm.isLastPage = () => vm.currentPage * itemsPerPage >= vm.totalItemsCount;

    const showPage = next => {
      vm.currentPage = vm.currentPage + next;
    };

    vm.getItemsCurrentPage = () => [...vm.campaignsList].splice((vm.currentPage - 1) * itemsPerPage, itemsPerPage);

    vm.pageForward = () => {
      const pageNext = vm.currentPage + 1;
      const pagesAvailable = Math.ceil(vm.campaignsList.length / itemsPerPage);
      const pagesAvailableTotal = Math.round(vm.totalItemsCount / itemsPerPage);

      if (pageNext > pagesAvailable && pagesAvailable < pagesAvailableTotal) {
        vm.loadNextChunk(1);
      } else {
        showPage(1);
      }
    };
    vm.pageBackward = () => {
      showPage(-1);
    };



    /* *************************************** */
    /* *************** Tabs ****************** */
    /* *************************************** */
    vm.tabActive = 'addNew';
    vm.setTabActive = tab => vm.tabActive = tab;



    /* *************************************** */
    /* ********** Expand/Collapse ************ */
    /* *************************************** */
    let expanded = [];
    vm.isExpanded = campaign => expanded.includes(campaign.pid);
    vm.toggleCollapse = campaign => {
      if (vm.isExpanded(campaign)) {
        expanded = expanded.filter(pid => pid !== campaign.pid);
      } else {
        expanded.push(campaign.pid);
      }
    };



    /* *************************************** */
    /* *********** Search logic ************** */
    /* *************************************** */
    vm.search = '';
    const hasMatchedTrackpoints = campaign => {
      if (!vm.search) {
        return false;
      }

      return campaign.trackpoints.some(item => (
        lower(item.name).includes(lower(vm.search)) ||
        lower(item.tailcode).includes(lower(vm.search))
      ));
    };

    const expandOnSearch = () => {
      expanded = [];
      vm.campaignsList.forEach(campaign => {
        if (hasMatchedTrackpoints(campaign) && !expanded.includes(campaign.pid)) {
          expanded.push(campaign.pid);
        }
      });
    };

    const handleServerSearch = _.debounce(() => {
      loadPage = 0
      vm.currentPage = 1;

      if (vm.search.length >= 3) {
        const term = encodeURIComponent(vm.search.trim().toLowerCase());
        const shared = 'Shared trackpoints';
        vm.isResponse504 = false;

        TrackpointService.search({ term }, ({ data }) => {
          vm.campaignsList = data
            .filter(item => item.name !== shared || (item.name === shared && item.trackpoints.length !== 0))
            .map(item => ({
              pid: item.pid,
              name: item.name,
              trackpoints: Object.keys(item.trackpoints).map(key => {
                const {
                  cid,
                  name,
                  active,
                  tailcode,
                  eventTypes,
                } = item.trackpoints[key];

                return {
                  cid,
                  name,
                  active,
                  tailcode,
                  eventTypes,
                };
              }),
            }));
          vm.totalItemsCount = data.length;
          vm.serverSearchProgress = false;

          showPage(0);
          checkTrackpointsAdded();
          expandOnSearch();
        }, error => {
          vm.serverSearchProgress = false;
          vm.isResponse504 = error.status === 504;
        });
      }

      if (!vm.search) {
        vm.serverSearchProgress = false;

        vm.campaignsList = [];
        vm.loadNextChunk();
      }
    }, 1000);

    $scope.$watch(() => vm.search,
      () => {
        vm.serverSearchProgress = true;
        handleServerSearch();
      }, true);



    /* *************************************** */
    /* ******* Add new trackpoint logic ****** */
    /* *************************************** */

    vm.processInput = function (e) {
      if (e && e.keyCode !== 13) return;
      e.preventDefault();

      //add from textarea
      if (vm.rawTrackpoints) {
        //replacing newlines with '-', then every '¤' replacing with '\n' and finally splitting on newline
        var lines = vm.rawTrackpoints.trim()
          .replace(/(\r\n|\n|\r)/g, "¤")
          .replace(/¤{1,}/gm, "\n")
          .split("\n");

        _.each(lines, function (line) {
          generateTrackpoint(line);
        });
        vm.rawTrackpoints = '';
      }
    };

    vm.setPrefix = function (trackpoint, cid) {
      trackpoint.cid = cid;
    };

    vm.remove = function (index) {
      vm.newTrackpoints.splice(index, 1);
      $scope.$broadcast('success', 'labas');
    };

    vm.canAddMore = function () {
      let count = vm.newTrackpoints.length;
      count += (typeof currentCampaign == 'undefined' || typeof currentCampaign.trackpoints == 'undefined') ?
        0 : currentCampaign.trackpoints.length;
      return count < vm.maxTrackpointsAllowed;
    };

    vm.addedTooMany = function () {
      var count = currentCampaign.trackpoints.length + vm.newTrackpoints.length;
      return count > vm.maxTrackpointsAllowed;
    };

    function generateTrackpoint(line) {
      // Parse the input (allowing empty cid+tailcodes)
      var parsedTrackpoint = parseTrackpointInput(line, true);

      // If the input line was entirely invalid (such as the string ";;") we skip the whole thing
      if (parsedTrackpoint === false) {
        return;
      }

      // If no cid was specified, use the current customer's CID/prefix
      if (parsedTrackpoint.cid == null) {
        parsedTrackpoint.cid = currentCampaign.cid;
      }
      // If no tailcode was specified, generate a random tailcode
      if (parsedTrackpoint.tailcode == null) {
        parsedTrackpoint.tailcode = angular.uniqueId();
      }

      parsedTrackpoint.properties = {
      featureTV: setFeatureTVstatus(),
      featureTVEnabled: 0
      };

      // Check if the trackpoint is not already in the modal list or the currentCampaign list, otherwise ignore
      if (!isAlreadyPresent(parsedTrackpoint)) {
        // Put valid trackpoints at the bottom of the list, and invalid trackpoints at the top of the list
        if (vm.isValid(parsedTrackpoint)) {
          vm.newTrackpoints.push({
            ...parsedTrackpoint,
            isNew: true,
          });
        } else {
          vm.newTrackpoints.unshift(parsedTrackpoint);
        }
      }
    }

    function setFeatureTVstatus() {
      return $('#current-user').data('feature-tv') === 1 ? 'auto' : 'off';
    }

    function isAlreadyPresent(trackpoint) {
      var present = false;
      angular.forEach(vm.newTrackpoints, function (newTrackpoint) {
        if (angular.equals(newTrackpoint, trackpoint)) {
          present = true;
        }
      });

      angular.forEach(currentCampaign.trackpoints, function (newTrackpoint) {
        if (angular.equals(newTrackpoint, trackpoint)) {
          present = true;
        }
      });

      return present;
    }

    /**
     * Parse a string like "TV3 topbanner video;USRtv3top2015" into its component parts
     *
     * Also accept the newer type: "TV3 topbanner video;USR;tv3top2015"
     *
     * Event type always defaults to impression.
     *
     * Returns an object like:
     * {
     *   name: 'TV3 topbanner video',
     *   cid: 'USR',
     *   tailcode: 'tv3top2015',
     *   eventTypes:
     *   {
     *      'impression': true
     *   }
     * }
     *
     * Returns false if invalid input
     */
    function parseTrackpointInput(trackpointInput, allowBlankTcode) {
      // allowBlankTcode defaults to false if not specified
      allowBlankTcode = angular.isUndefined(allowBlankTcode) ? false : allowBlankTcode;

      // Bad input type
      if (typeof trackpointInput !== 'string') {
        return false;
      }

      // Validate the input components
      var pair = trackpointInput.split(/[\t;]+/);
      var label;
      var cid;
      var tailcode;
      var eventType = 'impression';
      var response = {};

      if (pair.length == 1 && allowBlankTcode) {
        // Only one component found; we use this as the name since blank tcodes are allowed
        label = pair[0];

        // Validate name only
        var blankName = (label == ''),
            shortName = (label.length > 0 && label.length < 2);

        // Invalid components
        if (blankName || shortName) {
          return false;
        }

        response = {
          name: label,
          eventTypes: {},
          cid: null,
          tailcode: null
        };
        response.eventTypes[eventType] = true;
        return response;
      } else if (pair.length == 2) { // Oldschool [label];[tcode] input
        label = pair[0];
        var tcode = pair[1];

        // Validate oldschool
        var blankName = (label == ''),
            blankTcode = (tcode == ''),
            shortName = (label.length > 0 && label.length < 2),
            shortTcode = (tcode.length > 0 && tcode.length < 4);

        // Invalid components
        if (blankName
            || (blankTcode && !allowBlankTcode)
            || shortName
            || shortTcode) {
            return false;
        }

        cid = blankTcode ? null : tcode.substring(0, 3).toUpperCase();
        tailcode = blankTcode ? null : tcode.substring(3);
      } else if (pair.length == 3) { // New hotness [label];[cid];[tailcode] input
        label = pair[0];
        cid = pair[1];
        tailcode = pair[2];

        // Validate new hotness
        var blankName = (label == ''),
            blankCid = (cid == ''),
            blankTailcode = (tailcode == ''),
            shortCid = (cid.length > 0 && cid.length < 3),
            shortName = (label.length > 0 && label.length < 2),
            shortTailcode = (tailcode.length > 0 && tailcode.length < 2);

        // Invalid components
        if (blankName
            || (blankCid && !allowBlankTcode)
            || (blankTailcode && !allowBlankTcode)
            || shortName
            || shortCid
            || shortTailcode) {
            return false;
        }
      } else {
        // Component separator missing or too many separators found
        return false;
      }

      // All OK, return as an object
      response = {
        name: label,
        eventTypes: {},
        cid: cid,
        tailcode: tailcode
      };

      response.eventTypes[eventType] = true;
      return response;
    }


    /* -------------------------------------
      ReportItem validation logic
      ---------------------------------------*/

    /**
     * Check tracking code prefix against permitted prefixes for the current customer
     */
    vm.isAllowedPrefix = function (tp) {
      return _.any(vm.allowedCids, function (cid) {
        return cid.toLowerCase() == tp.cid.toLowerCase();
      });
    };

    /**
     * Check tracking code for special characters
     *
     * For the tailcode, we follow RFC 3986 (https://tools.ietf.org/html/rfc3986#section-2) for URL-safe ('unreserved') characters
     *
     * That is:
     *   unreserved  = ALPHA / DIGIT / "-" / "." / "_" / "~"
     *
     * (actually we accept parentheses "(" and ")" too, but that is just an UNDOCUMENTED FEATURE)
     */
    vm.isValidTrackpointCharacters = function (tp) {
      const uppercaseAlpha = /^[A-Z]*$/;
      const rfc3986 = /^[a-z0-9-\._~\(\)\/:]*$/i;
      return uppercaseAlpha.test(tp.cid) && rfc3986.test(tp.tailcode);
    };

      /**
      * Check tracking code name for special characters
      *
      * For the name, we allow most commonly-used characters, but we still whitelist them just in case
      */
    vm.isValidName = function (tp) {
      const allowedNameCharacters = /^[a-z0-9-\.:_~ ,!\/\\\\[\]|\$#%&\(\)=\+æøåäöü]+$/i;
      return allowedNameCharacters.test(tp.name);
    };

    /**
     * Check tracking code event type against whitelist
     */
    vm.isValidEventType = function (tp) {
      var allowedPublicEventTypes = [
        'impression',
        'click',
        'iv-supported',
        'iv-inview',
        'videostart',
        'videocomplete',
      ];
      var isValid = true;

      angular.forEach(tp.eventTypes, function (isPresent, eventType) {
        if (!(_.contains(allowedPublicEventTypes, eventType))) {
          isValid = false;
        }
      });
      return isValid;
    };

    /**
     * Check if the tracking code name is "Total" - which we disallow because it is confusing
     */
    vm.isNameNotReserved = function (tp) {
      var reservedTrackpointNames = ['Total'];
      return !_.any(reservedTrackpointNames, function (reservedName) {
        return reservedName.toLowerCase() == tp.name.toLowerCase();
      });
    };

    vm.isValid = function (tp) {
      return vm.isAllowedPrefix(tp) &&
        vm.isNameNotReserved(tp) &&
        vm.isValidName(tp) &&
        vm.isValidTrackpointCharacters(tp) &&
        vm.isValidEventType(tp);
    };

    // How many valid tracking points do we have
    vm.numberOfValidTrackpoints = function () {
      // filtering valid tracking points
      vm.validTrackpoints = _.filter(vm.newTrackpoints, function (tp) {
        return vm.isValid(tp);
      });
      return vm.validTrackpoints.length;
    };

    /* -------------------------------------
      Error popups handlers
      ---------------------------------------*/
    vm.openErrorModal = function (tp) {
      if (!vm.isNameNotReserved(tp)) {
        vm.openNameErrorModal(tp, 'total');
      }
      else if (!vm.isValidName(tp)) {
        vm.openNameErrorModal(tp, 'name');
      }
      else if (!vm.isValidTrackpointCharacters(tp)) {
        vm.openTcodeErrorModal(tp);
      }
      else if (!vm.isValidEventType(tp)) {
        vm.openEventTypeErrorModal(tp);
      }
      else if (!vm.isAllowedPrefix(tp)) {
        vm.openPrefixErrorModal(tp);
      }
    };

    vm.openPrefixErrorModal = function (tp) {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/error/prefix.html?v=${window.BUILD_VERSION}`,
          controller: "PrefixErrorModalController",
          controllerAs: 'prefixErrorModal',
          inputs: {
            companyCodes: cCodes
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (result) {
            tp.cid = result;
          });
        });
    };


    vm.openTcodeErrorModal = function (tp) {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/error/tcode.html?v=${window.BUILD_VERSION}`,
          controller: "TcodeErrorModalController",
          controllerAs: "tcodeErrorModal",
          inputs: {
            cid: tp.cid,
            tailcode: tp.tailcode
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (resultCid, resultTailcode) {
            tp.cid = resultCid;
            tp.tailcode = resultTailcode;
          });
        });
    };

    vm.openEventTypeErrorModal = function (tp) {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/error/eventtype.html?v=${window.BUILD_VERSION}`,
          controller: "EventTypeErrorModalController",
          controllerAs: "eventTypeErrorModal",
          inputs: {}
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (resultEventType) {
            tp.eventTypes = {};
            tp.eventTypes[resultEventType] = true;
          });
        });
    };


    vm.openNameErrorModal = function (tp, type) {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/error/name.html?v=${window.BUILD_VERSION}`,
          controller: "NameErrorModalController",
          controllerAs: 'nameErrorModal',
          inputs: {
            name: tp.name,
            type: type
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (result) {
            tp.name = result;
          });
        });
    };

    /* -------------------------------------
      Modal close functions
      ---------------------------------------*/

    vm.addTrackpoints = function () {

      angular.forEach(vm.validTrackpoints, function (tp) {
        currentCampaign.trackpoints.push(tp);
      });

      if (vm.validTrackpoints.length == 1) {
        Notification.onTpAdd(currentCampaign.pid, currentCampaign.name);
      } else if (vm.validTrackpoints.length > 1) {
        Notification.onTpAddMany(currentCampaign.pid, currentCampaign.name, vm.validTrackpoints.length);
      }

      CampaignManagerService.showNewTrackpointsAddedNotification(true);

      $element.modal('hide');
      close(null, 500);

      //remove trackpoints from array
      vm.newTrackpoints = [];
    };

    vm.close = function () {
      var shouldClose = vm.newTrackpoints.length == 0 ||
        confirm("You have created tracking points which are not yet added to the campaign. Close without adding?");
      if (shouldClose) {
        $element.modal('hide');
        close(null, 500);
        //remove trackpoints from array
        vm.newTrackpoints = [];
      }
    };
  }
})();
